import React from 'react';
import { formatAmount } from '../../datasets/utils/formatters';
import { TrendingUp, ArrowDownRight, ArrowUpRight, DollarSign } from 'lucide-react';

interface VolumeOverviewProps {
  estimatedPayments: number;
  estimatedPayouts: number;
  averageAmount: number;
  totalRevenue: number;
  totalBankFees: number;
  totalProfit: number;
}

export function VolumeOverview({
  estimatedPayments,
  estimatedPayouts,
  averageAmount,
  totalRevenue,
  totalBankFees,
  totalProfit
}: VolumeOverviewProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <div className="stat-card">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
            <ArrowDownRight className="w-4 h-4 text-slate-600" />
          </div>
          <span className="stat-label">Payment Volume</span>
        </div>
        <p className="stat-value">{formatAmount(estimatedPayments * averageAmount)}</p>
        <p className="mt-1 text-[13px] text-slate-500">
          {estimatedPayments.toLocaleString()} txns × {formatAmount(averageAmount)}
        </p>
      </div>
      
      <div className="stat-card">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center">
            <ArrowUpRight className="w-4 h-4 text-slate-600" />
          </div>
          <span className="stat-label">Payout Volume</span>
        </div>
        <p className="stat-value">{formatAmount(estimatedPayouts * averageAmount)}</p>
        <p className="mt-1 text-[13px] text-slate-500">
          {estimatedPayouts.toLocaleString()} txns × {formatAmount(averageAmount)}
        </p>
      </div>

      <div className="stat-card sm:col-span-2 lg:col-span-1">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
            <TrendingUp className="w-4 h-4 text-emerald-600" />
          </div>
          <span className="stat-label">Monthly Profit</span>
        </div>
        <p className="text-2xl font-bold text-emerald-600 mt-1.5">{formatAmount(totalProfit)}</p>
        <div className="mt-3 space-y-1.5 text-[13px]">
          <div className="flex justify-between text-slate-500">
            <span>Revenue</span>
            <span className="font-medium text-slate-700">{formatAmount(totalRevenue)}</span>
          </div>
          <div className="flex justify-between text-slate-500">
            <span>Bank Fees</span>
            <span className="font-medium text-slate-700">-{formatAmount(totalBankFees)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
